import React from 'react';
import './blog.css';
import {Article} from '../../components';
import {blog01, blog02, blog03, blog04, blog05 } from './imports'

const Blog = () => {
    return (
        <div className='gpt3__blog section__padding' id='Blog'>
            <div className='gpt3__blog-heading'>
                <h1 className='gradient__text'>Stay Ahead with the Latest in ECU Tuning & File Processing.</h1>
            </div>

            <div className='gpt3__blog-container'>
                <div className='gpt3__blog-container_groupA'>
                    <Article imgUrl={blog01} date='Feb 28, 2026' title="Advanced IMMO OFF Solutions for Modern Hitachi & Denso ECUs."/>
                </div>

                <div className='gpt3__blog-container_groupB'>
                    <Article imgUrl={blog02} date='Feb 20, 2026' title="Understanding Binary Structure Detection in Automotive Tuning."/>
                    <Article imgUrl={blog03} date='Feb 15, 2026' title="The Importance of Checksum Correction in ECU File Modification."/>
                    <Article imgUrl={blog04} date='Feb 10, 2026' title="Optimizing Performance: CAT OFF and DTC Management Explained."/>
                    <Article imgUrl={blog05} date='Feb 05, 2026' title="Prinzetuner: Engineering the Future of Professional File Processing."/>
                </div>
            </div>
        </div>
    )
}

export default Blog
